import React from 'react';
import { X } from 'lucide-react';

/**
 * Shared modal shell for document view/edit modals.
 * Matches TaxInvoiceForm design: company header, document type banner, consistent layout.
 */
const DocumentModalShell = ({ title, onClose, banner, companyProfile, children, maxWidth = 'max-w-6xl' }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-start justify-center z-50 p-2 sm:p-4 overflow-y-auto">
      <div className={`bg-white rounded-lg shadow-xl ${maxWidth} w-full max-h-[95vh] flex flex-col my-4 sm:my-8 relative overflow-hidden`}>
        <div className="bg-white border-b border-gray-200 px-4 sm:px-6 py-3 sm:py-4 flex items-center justify-between flex-shrink-0 sticky top-0 z-[100] rounded-t-lg shadow-sm">
          <h2 className="text-lg sm:text-xl font-semibold text-foreground">{title}</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
            <X className="w-5 h-5 sm:w-6 sm:h-6" />
          </button>
        </div>
        <div className="p-4 sm:p-6 space-y-4 sm:space-y-6 overflow-y-auto flex-1">
          {/* Company Header - matches TaxInvoiceForm */}
          <div className="border-b-2 border-gray-300 pb-4">
            <div className="flex flex-col sm:flex-row justify-between items-start gap-4">
              <div className="flex-1 w-full">
                <h1 className="text-xl sm:text-2xl font-bold text-foreground mb-2">
                  {companyProfile?.name || 'COMPANY NAME'}
                </h1>
                <div className="text-xs sm:text-sm text-gray-600 space-y-1">
                  <p>Address: {companyProfile?.address || 'Company Address'}</p>
                  <p>Mobile: {companyProfile?.phone || '—'} | Email: {companyProfile?.email || '—'}</p>
                  <p>GSTIN: {companyProfile?.gstin || '—'}</p>
                </div>
              </div>
              <div className="text-left sm:text-right w-full sm:w-auto">
                {companyProfile?.logoUrl ? (
                  <img src={companyProfile.logoUrl} alt="Company" className="h-12 sm:h-16 object-contain ml-auto" />
                ) : (
                  <div className="text-base sm:text-lg font-semibold text-primary">LOGO</div>
                )}
              </div>
            </div>
          </div>

          {/* Document Type Banner */}
          {banner && (
            <div className="bg-foreground text-white text-center py-2 sm:py-3 font-bold text-base sm:text-lg">
              {banner}
            </div>
          )}

          {children}
        </div>
      </div>
    </div>
  );
};

export default DocumentModalShell;
